// frontend/src/AccessibilityAudit/apiClient.js — thin wrapper around authenticatedFetch for /api/accessibility-audit
// (same shape as ClubSalesHistory/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/accessibility-audit';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const post = (path, body) => authenticatedFetch(`${BASE}${path}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}),
}).then(jsonOrThrow);

export const a11yApi = {
  sites: () => get('/sites'),
  report: (site) => get(`/sites/${site}/report`),
  checklist: (site, device) => get(`/sites/${site}/checklist?device=${device}`),
  history: (site) => get(`/sites/${site}/history`),
  current: () => get('/scans/current'),
  scan: (site) => post('/scans', { site_id: site }),
  scanAll: () => post('/scans', { all: true }),
  cancel: (id) => post(`/scans/${id}/cancel`),
  csv: async (site) => {
    const r = await authenticatedFetch(`${BASE}/sites/${site}/report.csv`);
    if (!r.ok) await jsonOrThrow(r);
    const name = (/filename="([^"]+)"/.exec(r.headers.get('Content-Disposition') || '') || [])[1] || `${site}_accessibility.csv`;
    return { blob: await r.blob(), name };
  },
  // Screenshots need the auth header, so they come back as blob URLs. The caller revokes them.
  screenshot: async (findingId) => {
    const r = await authenticatedFetch(`${BASE}/screenshots/${findingId}`);
    if (!r.ok) throw new Error(`${r.status}`);
    return URL.createObjectURL(await r.blob());
  },
};

export function download({ blob, name }) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
